const calendar = {

    availabilityMask: null,
    periods: null,
    translations: null,
    containerClass: null,
    today: null,
    yesterday: null,
    config: {},
    defaults: {
        availabilityMask: '',
        periods: [],
        translations: {},
        containerClass: '',
        dateFormat: "Y-m-d",
        showMonths: 5,
        nextArrow: '<i class="las la-angle-right la-2x"></i>',
        prevArrow: '<i class="las la-angle-left la-2x"></i>',

        checkOutClass: 'checkOutAllowed',
        checkInClass: 'checkInAllowed',
        notAvailableClass: 'notAvailable',
        notArrivalDepartureClass: 'disabled',
        notMinStayClass: 'disabled',

        rangeSeparator: ' - ',

        defaultDate: [],
    },

    init($elem, config, callback) {

        calendar.config = $.extend({}, calendar.defaults, config);

        calendar.today = new Date();
        calendar.today.setHours(0,0,0,0);

        calendar.yesterday = new Date(calendar.today.getTime());
        calendar.yesterday.setDate(calendar.yesterday.getDate() - 1);

        window.mobileAndTabletCheck = function () {
            let check = false;
            (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
            return check;
        };

        if(window.mobileAndTabletCheck()) {
            calendar.config.showMonths = 1;
        }


        let flatpickr = $elem.flatpickr({

                dateFormat: calendar.config.dateFormat,
                disableMobile: true,
                mode: "range",
                minRange: 0,
                showMonths: calendar.config.showMonths,
                inline: true,
                defaultDate: calendar.config.defaultDate,
                disable: [
                    function (date) {
                        return ! calendar.isAvailable(date);
                    }
                ],
                onDayCreate: function (dObj, dStr, fp, dayElem) {

                    let dateBefore = new Date(dayElem.dateObj.getTime());
                    dateBefore.setDate(dateBefore.getDate() - 1);

                    let dateIsAvailable = calendar.isAvailable(dayElem.dateObj);
                    let dateBeforeIsAvailable = calendar.isAvailable(dateBefore);

                    if (dateBeforeIsAvailable && ! dateIsAvailable) {
                        dayElem.className += ' ' + calendar.config.checkOutClass;
                    } else if ( ! dateBeforeIsAvailable && dateIsAvailable) {
                        dayElem.className += ' ' + calendar.config.checkInClass;
                    } else if ( ! dateIsAvailable) {
                        dayElem.className += ' ' + calendar.config.notAvailableClass;

                        /*$(dayElem).tooltip({
                            title: calendar.config.translations.not_available || ''
                        });*/
                    }

                    if ( ! calendar.hasPrice(calendar.config.periods, dayElem.dateObj)) {
                        dayElem.className += ' ' + calendar.config.notAvailableClass;

                        /*$(dayElem).tooltip({
                            title: calendar.config.translations.not_available || ''
                        });*/

                    } else {
                        if ( ! calendar.isArrivalPossible(calendar.config.periods, dayElem.dateObj)) {
                            dayElem.className += ' flatpickr-disabled ' + calendar.config.notArrivalDepartureClass;

                            /*if (fp.selectedDates[0]) {
                                $(dayElem).tooltip({
                                    title: calendar.config.translations.not_departure_day || ''
                                });
                            } else {
                                $(dayElem).tooltip({
                                    title: calendar.config.translations.not_arrival_day || ''
                                });
                            }*/
                        }

                        if (fp.selectedDates[0] && ! fp.selectedDates[1]) {
                            let minStay = calendar.getMinStay(calendar.config.periods, fp.selectedDates[0]);

                            if (minStay) {
                                // get difference between selected and current date of the loop
                                // check if min stay is met - skip selected date
                                let diff = calendar.dateDiff(dayElem.dateObj, fp.selectedDates[0]);
                                if (Math.abs(diff) < minStay) {
                                    dayElem.className += ' flatpickr-disabled ' + calendar.config.notMinStayClass;
                                    if (diff) {
                                        /*$(dayElem).tooltip({
                                            title: calendar.config.translations.min_stay_is && calendar.config.translations.min_stay_is.replace('{$min_stay}', minStay) || ''
                                        });*/
                                    }
                                }
                            }
                        }
                    }
                },
                onChange: function (selectedDates, dateStr, instance) {
                    if (callback) callback(calendar, selectedDates, dateStr, instance);
                },
                onReady: function (selectedDates, dateStr, instance) {

                    if (calendar.config.containerClass) {
                        let classList = instance.calendarContainer.classList;
                        let classes = calendar.config.containerClass.split(' ');
                        classes.forEach(function (css_class, index) {
                            classList.add(css_class);
                        });
                    }
                },

                nextArrow: calendar.config.nextArrow,
                prevArrow: calendar.config.prevArrow,
                locale: {
                    rangeSeparator: calendar.config.rangeSeparator
                }
        });

        return flatpickr;
    },
    isAvailable(date) {
        if (date < calendar.yesterday) {
            return 0;
        }

        /*if ( ! calendar.config.availabilityMask) return false;

        let diff = calendar.dateDiff(date, calendar.today);
        return +calendar.config.availabilityMask.substring(diff, diff + 1);*/
        return 1;
    },
    formatDate(date) {
        function pad(s) { return (s < 10) ? '0' + s : s; }
        let d = new Date(date);
        return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('.')
    },
    dateDiff(from, to) {
        let f = Date.UTC(from.getFullYear(), from.getMonth()+1, from.getDate());
        let t = Date.UTC(to.getFullYear(), to.getMonth()+1, to.getDate());

        return Math.round((from - to) / (1000 * 60 * 60 * 24));
    },
    isArrivalPossible(periods, date) {

        if ( ! periods.length) return false;

        let arrivalIsPossible = false;
        let dayOfWeek = date.getDay();
        dayOfWeek = (dayOfWeek == 0 ? 7 : dayOfWeek).toString();

        let period = calendar.filterPeriod(periods, date);


        if (period) {
            if ( ! period.days) {
                arrivalIsPossible = true;
            } else {
                let arrivalDays = period.days.split(',');

                if($.inArray(dayOfWeek, arrivalDays) !== -1) {
                    arrivalIsPossible = true;
                }
            }
        }

        return arrivalIsPossible;
    },
    filterPeriod(periods, date) {
        return $.grep(periods, function(period) {
            if (date >= calendar.cleanDate(period.dateFrom) && date < calendar.cleanDate(period.dateTo)) {
                return period;
            }
        })[0];
    },
    hasPrice(periods, date) {

        if ( ! periods.length) return false;

        return calendar.filterPeriod(periods, date) ? true : false;
    },
    getMinStay(periods, date) {

        if ( ! periods.length) return 0;

        let period = calendar.filterPeriod(periods, date);
        return period && period.minDays ? period.minDays : 0;
    },
    cleanDate(date) {
        date = new Date(date);
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
        return date;
    }
}
module.exports = {
    calendar: calendar
};